import { FC, useMemo } from 'react';

import { sourcesConfigFromDto, sourcesConfigToTree } from 'utils/campaign';
import { CampaignSubSource } from 'utils/constants/campaign';

import { Cell, CellText, Checkbox, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { setCampaignAllSources, setCampaignSubSource } from 'store/models/createCampaign';
import { useDispatch, useSelector } from 'store/utils';

interface AllSourcesProps {
    isEditAdvertising: boolean;
    sendAdSourcesTouchEvent: () => void;
}

const TrlKeys = {
    label: 'AdCreate.AdForm.AdSources.AllSources.label',
};

export const AllSources: FC<AllSourcesProps> = ({ isEditAdvertising, sendAdSourcesTouchEvent }) => {
    const { adSourcesConfig, adAllSources, adSource, savedSources } = useSelector((state) => state.createCampaign);

    const dispatch = useDispatch();
    const trl = useTrls();

    const enabledSources = useMemo(() => sourcesConfigFromDto(adSourcesConfig).enabledSources, [adSourcesConfig]);

    const sourcesTree = useMemo(() => {
        return sourcesConfigToTree(adSourcesConfig);
    }, [adSourcesConfig]);

    const enabledSubSourcesForEditAdvertising = useMemo(() => {
        if (!isEditAdvertising) return [];
        const result: CampaignSubSource[] = [];
        sourcesTree.forEach(({ subSources }) => {
            // сейчас мы не проверяем флаг enabled для редактирования рекламных РК с внешней ссылкой, так как отключенные площадки все равно нельзя включить
            const someSubSourcesSelected = subSources.some(({ subSource }) => adSource.includes(subSource));
            const someSubSourceSaved = subSources.some(({ subSource }) => savedSources.includes(subSource));
            if (someSubSourcesSelected || someSubSourceSaved) {
                result.push(...subSources.map(({ subSource }) => subSource));
            }
        });
        return result;
    }, [isEditAdvertising, sourcesTree, adSource, savedSources]);

    const onAllSourcesCheckboxChange = () => {
        sendAdSourcesTouchEvent();
        dispatch([
            setCampaignAllSources(!adAllSources),
            setCampaignSubSource(isEditAdvertising ? enabledSubSourcesForEditAdvertising : enabledSources),
        ]);
    };

    return (
        <>
            <Cell
                width="fit-content"
                left={
                    <Checkbox
                        onChange={onAllSourcesCheckboxChange}
                        checked={adAllSources}
                        data-qa="all-sources-checkbox-label"
                    />
                }
            >
                <CellText>{trl(TrlKeys.label)}</CellText>
            </Cell>
            <VSpacing default={12} />
        </>
    );
};
